export const STATUS_SUCCESS = 'SUCCESS';
export const STATUS_ERROR = 'ERROR';
